/* stylelint-disable */
import { colors } from 'css/constants';

const ReactToggleStyles = `
  .react-toggle {
    touch-action: pan-x;
    display: inline-block;
    position: relative;
    cursor: pointer;
    background-color: transparent;
    border: 0;
    padding: 0;
    -webkit-touch-callout: none;
    user-select: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-tap-highlight-color: transparent;
  }

  .react-toggle-screenreader-only {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  .react-toggle--disabled {
    cursor: not-allowed;
    opacity: 0.5;
    transition: opacity 0.25s;
  }

  .react-toggle-track {
    width: 42px;
    height: 24px;
    padding: 0;
    border-radius: 30px;
    background-color: #EEEEED;
    border: 1px solid #CCCCCB;
    transition: all 0.2s ease;
  }

  .react-toggle--checked .react-toggle-track,
  .react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {
    background-color: ${colors.lightGreen};
  }

  .react-toggle:hover:not(.react-toggle--disabled) .react-toggle-track {
    background-color: #CCCCCB;
  }

  .react-toggle-track-check {
    position: absolute;
    width: 14px;
    height: 10px;
    top: 0px;
    bottom: 0px;
    margin-top: auto;
    margin-bottom: auto;
    line-height: 0;
    left: 8px;
    opacity: 0;
    transition: opacity 0.25s ease;
  }

  .react-toggle--checked .react-toggle-track-check {
    opacity: 1;
    transition: opacity 0.25s ease;
  }

  .react-toggle-track-x {
    position: absolute;
    width: 10px;
    height: 10px;
    top: 0px;
    bottom: 0px;
    margin-top: auto;
    margin-bottom: auto;
    line-height: 0;
    right: 10px;
    opacity: 1;
    transition: opacity 0.25s ease;
  }

  .react-toggle--checked .react-toggle-track-x {
    opacity: 0;
  }

  .react-toggle-thumb {
    position: absolute;
    top: 1px;
    left: 1px;
    width: 22px;
    height: 22px;
    border: 1px solid #CCCCCB;
    border-radius: 50%;
    background-color: #FAFAFA;
    box-shadow: 0 2px 4px rgba(0,0,0,.3);
    transition: all 0.25s ease;
  }

  .react-toggle--checked .react-toggle-thumb {
    left: 19px;
    border-color: ${colors.lightGreen};
  }

  .react-toggle:hover .react-toggle-thumb {
    border-color: #CCCCCB;
  }
`;

export default ReactToggleStyles;
